import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  standalone: true,
  template: `<span [innerHTML]="safeHtml"></span>`,
  styles: [
    `
      span {
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    `,
  ],
})
export class TableHtmlRendererComponent implements ICellRendererAngularComp {
  readonly sanitizer = inject(DomSanitizer);

  safeHtml: SafeHtml = '';

  agInit(params: ICellRendererParams): void {
    this.updateHtml(params.value);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateHtml(params.value);
    return true;
  }

  private updateHtml(value: any): void {
    if (value === null || value === undefined) {
      this.safeHtml = '';
      return;
    }
    const htmlValue = typeof value === 'string' ? value : String(value);
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlValue);
  }
}
